import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  mainGrid: {
    padding: "0px",
    margin: "0px",
    minHeight: "calc(105vh - 105px)",
    "@media (max-width: 767.98px)": {
      minHeight: "auto",
    },
  },
  sideStyle: {
    borderRightWidth: "20px",
    borderRightStyle: "solid",
    borderImage: "linear-gradient(#2156a4, #32a6c4e3) 30",
  },

  //right div styles

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "2px solid #76787a",
    paddingBottom: "10px",
    margin: "10px 0px 10px 0px",
    color: "black",
    fontSize: "18px",
  },
  labels: {
    fontSize: "14px",
    color: "rgb(54 55 55)",
    marginLeft: "1%",
    textTransform: "uppercase",
  },
  valueLabels: {
    fontSize: "15px",
    marginLeft: "0.8em",
    fontWeight: 500,
  },
  cardHeaderStyle: {
    padding: "8px 10px",
    fontSize: "14px",
    backgroundColor: "#aeaeae54",
    fontWeight: 900,
    textTransform: "uppercase",
    boxShadow:
    "4px 3px #888888",
  },
  cardSubHeaderStyle: {
    padding: "4px 10px",
    fontSize: "14px",
    backgroundColor: "rgb(0 186 252)",
    color: "white",
    fontWeight: 900,
    textTransform: "uppercase",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    minHeight: "36px",
  },
  cardBody: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  cardBodyTitle: {
    fontSize: "16px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  cardBodyText: {
    fontSize: "14px",
    marginBottom: 0,
  },
  profile: {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    //objectFit: "contain",
    //border: "1px solid gray",
  },
  buttonStyle: {
    color: "#fff",
    ":focus" : {
      boxShadow: "none"
    },
  },
  buttonClass: {
    borderRadius: "20px",
    width: "25%",
    //backgroundColor: "#216ba5",
  },
  imgDivStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    flexWrap: "wrap",
  },
  imgStyle: {
    padding: "2px",
    display: "inline-flex",
    alignItems: "center",
  },
  editIconStyle: {
    width: "28px",
    cursor: "pointer",
    "@media (max-width: 575.98px)": {
      width: "24px",
    },
  },
  deleteIconStyle: {
    width: "15px",
    cursor: "pointer",
    "@media (max-width: 575.98px)": {
      width: "18px",
    },
  },
});

export default styles;
